import { BusIcon, ArrowRightIcon, UserIcon } from "assets/icons";

function BusCard({ data }) {
  return (
    <div className="w-full shadow-block rounded-[24px] p-6">
      <img src="/images/logo.jpeg" alt="logo" className="h-[44px] mb-3" />
      <div className="flex items-center">
        <span className="text-primary-700 mr-4">
          <BusIcon />
        </span>
        <div className="flex items-center text-sm font-semibold text-[#263238]">
          <span>{data?.board_city_name}</span>
          <span className="h-8 w-8 text-[#858585] px-2.5">
            <ArrowRightIcon />
          </span>
          <span>{data?.drop_city_name}</span>
        </div>
      </div>
      <div className="flex items-center py-3 my-3 border-t-[1px] border-b-[1px] border-[#C4C4C480]">
        <span className="text-primary-700 mr-4">
          <UserIcon />
        </span>
        <div className="w-full flex flex-col gap-0.5">
          <div className="text-[12px] leading-4 text-[#858585] font-semibold">
            Starting from
          </div>
          <div className="flex items-center text-sm font-semibold text-[#263238]">
            {`RM${data?.min_ticket_price} - RM${data?.max_ticket_price}`}
          </div>
        </div>
      </div>
      <div className="w-full flex items-center">
        <button className="w-full h-[48px] flex items-center justify-center bg-primary-700 text-white font-semibold rounded-[10px]">
          Select Seat
        </button>
      </div>
    </div>
  );
}

export default BusCard;
